'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC } from 'react';
import Service from '~/data/strapi/types/collection-types/service';
import nbspPreposition from '~/utils/nbsp-preposition';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

interface Props {
  services: Service[];
  useAccordions?: boolean;
}

const ServicesList: FC<Props> = ({ services }) => {
  const currentPath = usePathname();

  return (
    <ul className={styles.list}>
      {services.map((service) => {
        const serviceSlug = service.slug;

        if (!serviceSlug) return null;

        return (
          <li key={service.id} className={styles.item}>
            <Link
              href={`${currentPath}/${serviceSlug}`}
              className={styles.serviceTitle}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(nbspPreposition(service.title)) }}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default ServicesList;
